import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { ActivatedRoute, Params } from '@angular/router';
import { ExternalOfferSource } from '@tripbakers/enums/dist/enums/external-offer-source.enum';

@Component({
  selector: 'app-housing-search-housing-element',
  templateUrl: './housing-element.component.html',
  styleUrls: ['./housing-element.component.css'],
})
export class HousingElementComponent implements OnInit {
  @Input('housing') housing: any;
  @Input() index: any;
  public id: number;
  public environment = environment;

  get isExpediaConnectEnabled() {
    return (
      this.housing &&
      this.housing.externalSourceOfferDetails &&
      this.housing.externalSourceOfferDetails.enabled &&
      this.housing.externalSourceOfferDetails.provider ===
        ExternalOfferSource.EXPEDIA
    );
  }
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {}
}
